<script setup>
import { __ } from '@/utils';
import { Field, ErrorMessage, useField } from 'vee-validate';
import FieldCity from '@components/fieldCity/fieldCity.vue';
import { useDisableCityField } from '@composables/useDisableCityField';

const props = defineProps(['name']);
 
const { handleChange } = useField(`${props.name}POCityCode`);

const handleSelectedCity = ({code}) => handleChange(code);

const { disableCityField } = useDisableCityField(props.name);
</script>
<template>
    <div class="fields__body">
        <FieldCity
            class="field--w247"
            :name="`${name}POSettlement`"
            :label="`${__('Settlement')} *`"
            @selected="handleSelectedCity" 
            :disabled="disableCityField"
        />
        
        <div class="field field--w247">
            <ErrorMessage :name="`${name}PO`" as="span" class="field__error" />

            <label for="field-settlement-subscriber">
                {{ __('P.O.') }} *
            </label><!-- /.form__label -->

            <Field
                type="text"
                id="field-settlement-subscriber" 
                :name="`${name}PO`"
                :disabled="disableCityField"
            />
        </div><!-- /.field -->
    </div><!-- /.fields__body -->
</template>